var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tile outer-border",class:[_vm.props.classes]},[_c('img',{staticClass:"img-slot-bg",attrs:{"src":_vm.props.bgImage,"alt":""}}),_c('div',{staticClass:"inner-border"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }